var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4PassTokens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9504 4.80029L1.81381 11.9073C0.122792 13.5913 0.122792 16.3216 1.81381 18.0056L8.9504 25.1126C10.6414 26.7966 13.3831 26.7966 15.0741 25.1126L22.2107 18.0056C23.9017 16.3216 23.9017 13.5913 22.2107 11.9073L15.0741 4.80029C13.3831 3.11629 10.6414 3.11629 8.9504 4.80029Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9504 4.80029L1.81381 11.9073C0.122792 13.5913 0.122792 16.3216 1.81381 18.0056L8.9504 25.1126C10.6414 26.7966 13.3831 26.7966 15.0741 25.1126L22.2107 18.0056C23.9017 16.3216 23.9017 13.5913 22.2107 11.9073L15.0741 4.80029C13.3831 3.11629 10.6414 3.11629 8.9504 4.80029Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08105 12.0599V17.8639C8.08105 18.4232 8.53635 18.8766 9.09798 18.8766H14.9261C15.4878 18.8766 15.9431 18.4232 15.9431 17.8639V12.0599C15.9431 11.5006 15.4878 11.0472 14.9261 11.0472H9.09798C8.53635 11.0472 8.08105 11.5006 8.08105 12.0599Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9229 9.66424C21.8473 6.04899 25.6745 3.58801 30.0702 3.58801C36.4123 3.58801 41.5516 8.70598 41.5516 15.0218C41.5516 21.3376 36.4123 26.4555 30.0702 26.4555C25.6745 26.4555 21.8473 23.9945 19.9229 20.3793",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1682 17.1016C32.1671 17.1016 33.7876 15.4879 33.7876 13.4973C33.7876 11.5066 32.1671 9.89291 30.1682 9.89291C28.1693 9.89291 26.5488 11.5066 26.5488 13.4973C26.5488 15.4879 28.1693 17.1016 30.1682 17.1016Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9798 24.9419C34.9798 22.2414 32.782 20.0417 30.0593 20.0417C27.3365 20.0417 25.1387 22.2305 25.1387 24.9419",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0984,
    height: 24,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4PassTokens);
export default __webpack_public_path__ + "static/media/4-pass-tokens.de3bba242d42398eccbd778b32ec040a.svg";
export { ForwardRef as ReactComponent };